import { MagnifyingGlassIcon, PlusIcon } from "@heroicons/react/24/outline";
import { FACILITY_STATUS_TABS } from "../../constants/facility.constants";

const FacilitySearchBar = ({ search, onSearchChange, status, onStatusChange, onAddFacility, canAddFacility }) => (
  <div className="mb-5 flex flex-wrap items-center gap-3">
    <div className="relative w-full flex-none min-w-0 sm:w-auto sm:flex-1 sm:min-w-[260px]">
      <MagnifyingGlassIcon className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
      <input
        type="text"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Search facility by name, domain or city..."
        className="w-full rounded-2xl border border-gray-200 bg-white py-2.5 sm:py-3 pl-11 pr-4 text-sm text-gray-700 placeholder:text-gray-400 focus:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-100"
      />
    </div>

    <div className="flex items-center gap-0.5 rounded-xl border border-gray-100 bg-white p-1">
      {FACILITY_STATUS_TABS.map((tab) => (
        <button
          key={tab.value}
          type="button"
          onClick={() => onStatusChange(tab.value)}
          className={`rounded-lg px-3 sm:px-4 py-2 text-sm transition-colors ${
            status === tab.value
              ? "bg-[#14122B] font-semibold text-white"
              : "font-medium text-gray-500 hover:text-gray-900"
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>

    {canAddFacility && (
      <button
        type="button"
        onClick={onAddFacility}
        className="ml-auto inline-flex items-center gap-2 rounded-2xl bg-[#2B3674] px-4 sm:px-5 py-3 text-sm font-semibold text-white hover:bg-blue-800"
      >
        <PlusIcon className="h-4 w-4" />
        Add<span className="hidden sm:inline"> Facility</span>
      </button>
    )}
  </div>
);

export default FacilitySearchBar;
